var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { css } from '@patternfly/react-styles';
import PropTypes from 'prop-types';

var propTypes = {
  /** Additional classes added to the Brand. */
  className: PropTypes.string,
  /** Attribute that specifies the URL of the image for the Brand. */
  src: PropTypes.string,
  /** Attribute that specifies the alt text of the image for the Brand. */
  alt: PropTypes.string.isRequired
};

var defaultProps = {
  className: '',
  src: ''
};

var Brand = function Brand(_ref) {
  var className = _ref.className,
      src = _ref.src,
      alt = _ref.alt,
      props = _objectWithoutProperties(_ref, ['className', 'src', 'alt']);

  return (
    /** the brand component currently contains no styling
     the 'pf-c-brand' string will be used for the className */
    React.createElement('img', _extends({}, props, { className: css('pf-c-brand', className), src: src, alt: alt }))
  );
};

Brand.propTypes = propTypes;
Brand.defaultProps = defaultProps;

export default Brand;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Brand/Brand.js
// module id = 219
// module chunks = 0